/* eslint-disable security/detect-object-injection */
import './StatusField.style.less'

import { STATUS_LABEL_COLOR } from './StatusField.constant'
import { get, startCase } from 'lodash'
import SetStatusDialog from './components/SetStatusDialog/SetStatusDialog'
import { useState } from 'react'
import { CheckOutlined, CloseOutlined, EditFilled } from '@ant-design/icons'
import PBFPermission from '@/screens/Order/components/PBFPermission'
import moment from 'moment'
import { currentSelectedCollaborator } from '@/jotai/order.jotai'
import { useAuth } from '@/providers/auth.provider'
import { useAtom } from 'jotai'

interface Prop {
  task_type: string
  current_status: string
  data: any
  onApprovalChange: (status: string, actualDate: any) => any
  fieldName: string
}

export function StatusField(props: Prop) {
  const { current_status, data, onApprovalChange } = props
  const [visible, setvisible] = useState(false)

  const [currentCollaborator] = useAtom(currentSelectedCollaborator)
  const { user } = useAuth()

  const findIsAssignedAndIsUpdater = () => {
    const isUserIsCollaborator = currentCollaborator?.find(
      (collaborator) => collaborator?.user?.id === user?.id
    )
    const currentUserAssigned = props.data.assignments?.find(
      (assignment) => assignment?.user?.id === isUserIsCollaborator?.user.id
    )
    return (
      currentUserAssigned?.user?.id == user?.id &&
      isUserIsCollaborator.roles?.role === 'updater' &&
      !['submitted'].includes(current_status)
    )
  }

  const showPassIndicator = () => {
    return current_status == 'approved' ||
      current_status == 'done' ||
      current_status == 'pass' ? (
      <div className="pass-indicator">
        <CheckOutlined />
      </div>
    ) : findIsAssignedAndIsUpdater() ? (
      <div className="edit-icon">
        <EditFilled />
      </div>
    ) : (
      <PBFPermission roles={['owner', 'doer', 'editor']}>
        <div className="edit-icon">
          <EditFilled />
        </div>
      </PBFPermission>
    )
  }

  const showPassFailIndicator = () => {
    return current_status == 'fail' || current_status == 'rejected' ? (
      <div className="fail-indicator">
        <CloseOutlined />
      </div>
    ) : (
      showPassIndicator()
    )
  }

  return (
    <>
      <PBFPermission
        roles={[
          'owner',
          'doer',
          'editor',
          findIsAssignedAndIsUpdater() && 'updater',
        ]}
        showComponent
      >
        <div
          className="clickable plan-field-status-container"
          onClick={() => {
            setvisible(true)
          }}
        >
          <div className="value-container">
            <div className="field-content">
              {data?.progress_status === 'new' ? (
                <div className="status-label">{`Not Planned`}</div>
              ) : (
                <div
                  className={`status-label ${get(
                    STATUS_LABEL_COLOR,
                    current_status
                  )}`}
                >
                  {startCase(current_status.toLowerCase())}
                </div>
              )}
            </div>
            {data?.actual_date && (
              <p>{moment(data?.actual_date).format('DD MMM YYYY')}</p>
            )}
          </div>
          {showPassFailIndicator()}
        </div>
      </PBFPermission>

      {visible && (
        <SetStatusDialog
          visible={visible}
          current_status={current_status}
          onClose={() => {
            setvisible(false)
          }}
          onApprovalChange={onApprovalChange}
          data={data}
          fieldName={props.fieldName}
        />
      )}
    </>
  )
}
